import React, { useContext } from 'react';
import { StyleSheet, View } from 'react-native';
import { Text, ThemeContext } from '..';

/*eslint-disable react-native/no-unused-styles*/
const getStyles = (theme: Theme): Record<string, Record<string, string | number>> =>
  StyleSheet.create({
    container: {
      flexDirection: 'row',
      alignItems: 'center',
    },
    title: {
      fontSize: 13,
      color: theme.colors.primary.normal,
      marginRight: 10,
    },
  });

interface ToggleFrameButtonProps {
  title?: string;
  rtl?: boolean;
}

export const ToggleFrameButton = ({ rtl, title }: ToggleFrameButtonProps): React.JSX.Element=> {
  const theme = useContext(ThemeContext);
  const styles = getStyles(theme);

  const { IconComponent, icons } = theme;

  return (
    <View style={styles.container}>
      {title && <Text style={styles.title}>{title}</Text>}
      <IconComponent
        color={theme.colors.primary.normal}
        name={icons.arrowRight}
        size={14}
        style={{ transform: [{ scaleX: rtl ? -1 : 1 }] }}
      />
    </View>
  );
};
